import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, LoadingController, ModalController, App } from 'ionic-angular';
// import { Clipboard } from '@ionic-native/clipboard';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';
import { TabsPage } from '../tabs/tabs';
import { CreatewallPage } from '../createwall/createwall';

/**
 * Generated class for the MultiregistPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-multiregist',
  templateUrl: 'multiregist.html',
})
export class MultiregistPage {
    loginId: string;
    api_key: string;
    version: string;
    office_email: string;
    email: string;
    unit: string;
    coin_unit: string;
    wallet_address: string;
	total_sale: string;
	total_gold: string;

	owners: any = [];
	list: any = [];
    items: any = [];
    // count_items: number = 0;
    max_items: number = 0;

    
    texts : any = [];
    language: string;
    
    top_user: string;
    top: boolean = false;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
		// private clipboard: Clipboard,
        public alertCtrl: AlertController,
		public loadingCtrl: LoadingController,
		public modalCtrl: ModalController,
		public app: App,
        private http: HttpService
    ) {

    }

    ionViewWillEnter() {
        //// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
        if(!this.api_key) {
            this.app.getRootNav().setRoot(LoginPage);
        }

        //// 페이지 이름
        localStorage.setItem("pageName", "mygroup");
        this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
        // this.point_unit = localStorage.getItem("point_unit");

		this._init('');
		
		this._get_texts();

	}
	
	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).multiregist;
	}

    // _copyAdd(item) {
	// 	this.clipboard.copy(this.wallet_address);
	// 	let alert = this.alertCtrl.create({
    //         title: "Copy",
    //         message: item,
	// 	    buttons: ['OK']
	// 	});
	// 	alert.present();
    // }
    
    // _invite() {
    //     this.navCtrl.push(InvitePage);
    // }

    _multi_login(member) {
        let url = "login/index/sockpuppet";
        let body= JSON.stringify({
            api: this.api_key,
            version: this.version,
            language: this.language,
            member: member.user
        });
        
        this.http.post(url,body).then((res:any)=>{
            if(res.result=="OK"){
                localStorage.setItem("api_key", res.api);
                this.office_email = res.office_email;
                this.email = res.email;
                this.unit = res.unit;
                this.coin_unit = res.coin_unit;
                localStorage.setItem('email' , this.email);
                localStorage.setItem('office_email' , this.office_email);
                localStorage.setItem('coin_unit' , res.coin_unit);
                localStorage.setItem('unit' , res.unit);
                localStorage.setItem('unit_name' , this.texts.unit_name);
                localStorage.setItem('coin_name' , this.texts.coin_name);
                localStorage.setItem('token_unit' , this.texts.token_unit);
                localStorage.setItem('token_name' , this.texts.token_name);
                
                localStorage.setItem("id", member.id);
                localStorage.setItem("loginId", member.id);

                localStorage.removeItem("reLoginId");
                localStorage.setItem("reLoginId", member.id);

                // this._init('');
                // this._joinChat(res.api);

                this.app.getRootNav().setRoot(TabsPage);
            } else if(res.result == "NO_WALLET"){
                localStorage.setItem("api_key", res.api);
                
                localStorage.setItem("id", member.id);
                localStorage.setItem("loginId", member.id);

                localStorage.removeItem("reLoginId");
                localStorage.setItem("reLoginId", member.id);

                this.navCtrl.setRoot(CreatewallPage, {id : member.id});

            } else if(res.result ==="LOGOUT"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                localStorage.removeItem("loginId");
                this.app.getRootNav().setRoot(LoginPage);
            
            } else {

                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
            }
        },(err)=>{

            let alert: any;
            if(err.status == 0) {
                alert = this.alertCtrl.create({						
                    message: err.message,
                    buttons: ['OK']
                });
            } else {
                alert = this.alertCtrl.create({						
                    message: err,
                    buttons: ['OK']
                });
            }
            alert.present();
        });

    }

    _add() {

        let url = "user/sockpuppet/index/save";
        let body = JSON.stringify({
            api: this.api_key,
            language: this.language,
            version: this.version,
            member: this.owners.user

        });
        this.http.post(url, body).then((res: any) => {
            if(res.result=="OK"){
                this._init('add');
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();

            } else {
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
            }
        },(err)=>{	
            //// HTTP 에러인 경우
            let alert = this.alertCtrl.create({
                message: this.texts.alertM_err,
                buttons: ['OK']
            });
            alert.present();
        });

		// let modal = this.modalCtrl.create(AccountPage, {chucheon: this.owners});
		// modal.present();
		// modal.onDidDismiss( data => {
		// 	this._init('');
		// 	// if (data == '' || data == null || data == undefined) {
		// 	// 	return;
		// 	// } else {
		// 	// 	this.ref({'up': '', 'idx': data});
		// 	// }
		// });
	}

    _init(event) {
		// this.top_card = [];

		let url = "user/sockpuppet/index/add";
		let body;
		if (event == '') {
			body = JSON.stringify({ 
				api: this.api_key,
				language: this.language,
				version: this.version
			});
		} else if (event == 'add') {
            body = JSON.stringify({ 
                api: this.api_key,
                language: this.language,
                version: this.version,
                member: this.owners.user,
                mode: ""
                
            });
        } else {
			if(event.up != '' && event.click == '') {
				if ( event.up.user_id == this.loginId) {
					// loader.dismiss();
					return;
				} else {
					body = JSON.stringify({
						api: this.api_key,
						language: this.language,
                        version: this.version,
						member: event.up.user,
						mode: "UP"
					});
				}
			} else if (event.up == '' && event.click != '') {
				body = JSON.stringify({ 
					api: this.api_key,
					language: this.language,
                    version: this.version,
					member: event.click,
					mode: ""
					
				});
			}
        }
        let loader = this.loadingCtrl.create({
			content: "loading..."
		});
        loader.present();
        
        this.owners = [];
        this.items = [];

		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
                this.owners = res.owner[0];

                if (event == '') {
                    this.top_user = res.owner[0].user;
                }	

                this.items = res.list;
                // this.list = res.list;
                // this.max_items = res.list.length;
                // this.items = [];
                // // this.count_items = 0;
                // for (var i = 1; i < this.max_items; i++) {
                // 	// if(this.max_items <= this.count_items) break;
                // 	this.items.push(this.list[i]);
                // 	// this.count_items ++;
                // }

                if (this.top_user == this.owners.user) {
                    this.top = true;
                } else {
                    this.top = false;
                }
                
                loader.dismiss();
			} else if(res.result ==="LOGOUT"){
				loader.dismiss();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginEmail");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else if(res.result ==="DONOT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				this.navCtrl.pop();
			
			} else {
				loader.dismiss();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
			
		},(err)=>{	
			loader.dismiss();
			//// HTTP 에러인 경우
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
		
		});
	}

	_close() {
		this.navCtrl.pop();
	}
}



// WEBPACK FOOTER //
// ./src/pages/multiregist/multiregist.ts